import { EventEmitter, Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class CommunicationService {
	private readonly openChatSubject = new Subject<void>();
	public readonly openChatEvent$ = this.openChatSubject.asObservable();

	openChat() {
		this.openChatSubject.next();
	}
}
